import React from 'react';
import { render } from 'react-dom';
import Root from './ui/Root';

render(React.createElement(Root), document.body);